module.exports = __webpack_public_path__ + "static/media/LeaveChecks_Animation.034f9d1c.gif";